

import React, { useState, useEffect } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';
import LoginLogo from '../../Assets/images/Frame 39059 1.png';
import LoginImg from '../../Assets/images/Registra.png';
import GoogleLogo from '../../Assets/images/GoogleLogo.png';
import SignupBackground from '../../Assets/images/SignupBackground.png';
import Swal from 'sweetalert2';
import apiClient from '../../Api/apiClient';
import { API_BASE_URL } from '../../Api/config';
import LocationSelector from '../../Components/Location/Location';

const SignUpAffilate = () => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [password, setPassword] = useState('');
  const [passwordReTypeVisible, setPasswordReTypeVisible] = useState(false);
  const location = useLocation();
  const { PricingBeforLogin, FromCheckoutAlert } = location.state || {};
  const [userName, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [ReTypepassword, setReTypepassword] = useState('');
  const [errors, setErrors] = useState({});
  const [countryCode, setCountryCode] = useState('88'); // Set default country code
  const [passwordStrength, setPasswordStrength] = useState({
    minLength: false,
    uppercase: false,
    lowercase: false,
    number: false,
    specialChar: false,
  });
  const [selectedLocation, setSelectedLocation] = useState({
    districtId: null,
    districtName: '',
    upazilaId: null,
    upazilaName: '',
  });
  const [selectedCategory, setSelectedCategory] = useState({
    subsectorId: null,
    subsectorName: '',
  });

  const [matchedPhone, setMatchedPhone] = useState(false);
  const [matchedEmail, setMatchedEmail] = useState(false);

  const handleLocationSelect = (
    districtId,
    districtName,
    upazilaId,
    upazilaName
  ) => {
    setSelectedLocation({ districtId, districtName, upazilaId, upazilaName });
  };

  const navigate = useNavigate();

  const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);
  const toggleReTypePasswordVisibility = () =>
    setPasswordReTypeVisible(!passwordReTypeVisible);

  const validateForm = () => {
    const newErrors = {};
    if (!userName) newErrors.userName = 'Phone is required';
    // if (!email) newErrors.email = 'Email is required';
    if (!password) newErrors.password = 'Password is required';
    if (!ReTypepassword)
      newErrors.ReTypepassword = 'Confirm Password is required';
    return newErrors;
  };

  const handleSignUp = async () => {
    const validationErrors = validateForm();

    const formData = {
      phone: `${countryCode}${userName}`,
      email: email,
      password: password,
      retype_password: ReTypepassword,
      district_id: selectedLocation.districtId,
      upazila_id: selectedLocation.upazilaId,
      sub_sector_id: selectedCategory.subsectorId,
    };

    if (Object.keys(validationErrors).length === 0) {
      try {
        const response = await apiClient.post(
          `${API_BASE_URL}/auth/affiliator/sign-up`,
          formData
        );
        // console.log(response.data);
        // const {
        //   data: { user_type },
        // } = response.data;
        const successMessage = response.data.message;
        Swal.fire({
          title: 'Success!',
          text: successMessage,
          confirmButtonText: 'Okay',
          customClass: {
            popup: 'w-72 h-auto p-3',
            title: 'text-lg',
            content: 'text-xs',
            confirmButton:
              'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
          },
        });
        navigate('/verify-affiliator-otp', {
          state: {
            phone: `${countryCode}${userName}`,
            PricingBeforLogin: PricingBeforLogin,
            FromCheckoutAlert: FromCheckoutAlert,
            userType: 'affiliator',
          },
        });
      } catch (error) {
        console.error('Signup failed:', error);
        const errorMessage = error.response?.data?.message;
        Swal.fire({
          title: 'Failed!',
          text: errorMessage,
          confirmButtonText: 'Okay',
          customClass: {
            popup: 'w-72 h-auto p-3',
            title: 'text-lg',
            content: 'text-xs',
            confirmButton:
              'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
          },
        });
      }
    } else {
      setErrors(validationErrors);
    }
  };

  const handleSignUpKey = e => {
    if (e.key === 'Enter') {
      handleSignUp();
    }
  };

  const handlePasswordChange = value => {
    setPassword(value);
    setPasswordStrength({
      minLength: value.length >= 8,
      uppercase: /[A-Z]/.test(value),
      lowercase: /[a-z]/.test(value),
      number: /\d/.test(value),
      specialChar: /[!@#$%^&*]/.test(value),
    });
  };

  useEffect(() => {
    const checkUserDetails = async () => {
      if (userName || email) {
        const phoneNumber = `${countryCode}${userName}`;
        
        // First, check if phone exists
        const phoneResponse = await checkPhoneExists(phoneNumber);
        // Then, check if email exists
        const emailResponse = await checkEmailExists(email);
  
        // Handle phone number error
        if (phoneResponse.phoneExists) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            userName: 'This phone number is already registered.',
          }));
        } else {
          setErrors((prevErrors) => ({
            ...prevErrors,
            userName: '',
          }));
        }
  
        // Handle email error
        if (emailResponse.emailExists) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            email: 'This email is already registered.',
          }));
        } else {
          setErrors((prevErrors) => ({
            ...prevErrors,
            email: '',
          }));
        }
      }
    };
  
    checkUserDetails();
  }, [userName, email, countryCode]);
  

  const checkPhoneExists = async (phone) => {
    try {
      const queryParams = new URLSearchParams();
      if (phone) queryParams.append('phone', phone);
      queryParams.append('user_type', "affiliator");
  
      const response = await apiClient.get(
        `${API_BASE_URL}/user/visitor/users?${queryParams.toString()}`
      );
  
      if (response.data.data) {
        const user = response.data.data[0];
        return { phoneExists: user.phone === phone };
      }
      return { phoneExists: false };
    } catch (error) {
      console.error('Error checking phone:', error);
      return { phoneExists: false };
    }
  };
  

  const checkEmailExists = async (email) => {
    try {
      const queryParams = new URLSearchParams();
      if (email) queryParams.append('key', email);
      queryParams.append('user_type', "affiliator");
  
      const response = await apiClient.get(
        `${API_BASE_URL}/user/visitor/users?${queryParams.toString()}`
      );
  
      if (response.data.data) {
        const user = response.data.data[0];
        return { emailExists: user.email === email };
      }
      return { emailExists: false };
    } catch (error) {
      console.error('Error checking email:', error);
      return { emailExists: false };
    }
  };
  
  
 

  const isFormValid = userName && password && ReTypepassword; 
  const isButtonDisabled = matchedPhone || matchedEmail || !isFormValid;

  return (
    <div
      className="flex items-center bg-center object-cover justify-center px-4 py-4"
      style={{ backgroundImage: `url(${SignupBackground})` }}
    >
      <div className="flex flex-col lg:flex-row overflow-hidden max-w-5xl w-full rounded-lg border">
        {/* Left Section */}
        <div className="lg:w-1/2 w-full md:p-6 md:pt-0 p-0 flex flex-col items-center justify-center">
          <img src={LoginLogo} alt="TenderWise Logo" className="h-16 " />
          <h1 className="text-sm text-gray-600 text-center mb-2">
            Register and join as a Affiliator
          </h1>
          <img
            src={LoginImg}
            alt="Illustration"
            className="md:mt-4 w-72 h-60 max-w-xs lg:max-w-sm md:block hidden"
          />
        </div>

        {/* Right Section */}
        <div className="lg:w-1/2 w-full md:p-8 p-2">
          <h2 className="md:text-xl text-lg font-semibold text-gray-800 text-center ">
            Create an account
          </h2>
          <p className="text-sm text-center text-gray-600 mb-4">
            Already have an account?{' '}
            <button
  onClick={() => navigate('/affiliator-login')}
   className="font-semibold bg-DefaultColor text-white hover:underline  hover:bg-DefaultHoverColor  px-2 py-0.5 text-xs rounded-md transition-all duration-300 ease-in-out transform hover:scale-105"
>
  Log In
</button>

          </p>
          {/* Form */}
          <div className="space-y-2 mt-2">
            {/* username*/}
            <div className="flex space-x-1">
              <select
                className="border text-xs border-gray-300 rounded-md py-2 px-1 w-24"
                value={countryCode}
                onChange={e => setCountryCode(e.target.value)}
              >
                <option value="88">+88(Ban)</option>
                <option value="1">+1(USA/Canada)</option>
                <option value="44">+44(UK)</option>
                <option value="91">+91(India)</option>
                <option value="61">+61(Aust)</option>
                <option value="33">+33(France)</option>
                <option value="49">+49(Germany)</option>
                <option value="39">+39(Italy)</option>
                <option value="81">+81(Japan)</option>
                <option value="7">+7(Russia)</option>
                <option value="86">+86(China)</option>
                <option value="34">+34(Spain)</option>
                <option value="55">+55(Brazil)</option>
                <option value="27">+27(SA)</option>
                <option value="52">+52(Mexico)</option>
                <option value="20">+20(Egypt)</option>
                <option value="45">+45(Denmark)</option>
                <option value="31">+31(Netherlands)</option>
                <option value="90">+90(Turkey)</option>
                <option value="63">+63(Philippines)</option>
                <option value="66">+66(Thailand)</option>
                <option value="32">+32(Belgium)</option>
                <option value="56">+56(Chile)</option>
                <option value="46">+46(Sweden)</option>
                <option value="351">+351(Portugal)</option>
                <option value="965">+965(Kuwait)</option>
                <option value="971">+971(UAE)</option>
                <option value="30">+30(Greece)</option>
                <option value="972">+972(Israel)</option>
                <option value="964">+964(Iraq)</option>
                <option value="256">+256(Uganda)</option>
              </select>
              <input
                type="text"
                placeholder="Enter Phone Number"
                className="border text-xs border-gray-300 rounded-md py-2 px-2 w-full"
                value={userName}
                onChange={e => setUsername(e.target.value)}
                onKeyDown={handleSignUpKey}
              />
            </div>
            {errors.userName && (
              <p className="text-red-500 text-xs mb-0 -mt-2">
                {errors.userName}
              </p>
            )}
            
  
  {matchedPhone && (
    <p className="text-red-500 text-xs mb-0 -mt-2">
      This phone number already exists. Please give another one
    </p>
  )}
  

  

            {/* Email */}
            <div>
              <input
                type="email"
                id="email"
                placeholder="Enter your Email"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 text-xs focus:ring-blue-500 focus:border-blue-500"
                value={email}
                onChange={e => setEmail(e.target.value)}
                onKeyDown={handleSignUpKey}
              />

{email && matchedEmail && (
    <p className="text-red-500 text-xs mb-0 mt-2">
      This Email already exists. Please give another one
    </p>
  )}
            </div>

            {/* Password */}
            <div>
              <div className="relative">
                <input
                  type={passwordVisible ? 'text' : 'password'}
                  id="password"
                  placeholder="Enter your password"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 text-xs focus:ring-blue-500 focus:border-blue-500"
                  value={password}
                  onChange={e => handlePasswordChange(e.target.value)}
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500"
                  onClick={togglePasswordVisibility}
                >
                  {passwordVisible ? <FaEye /> : <FaEyeSlash />}
                </button>
              </div>
              {/* Password Strength Checklist */}
              {password && (
                <div className="mt-2 text-xs text-gray-600 space-y-1">
                  <p
                    className={
                      passwordStrength.minLength
                        ? 'text-green-600'
                        : 'text-red-600'
                    }
                  >
                    {passwordStrength.minLength
                      ? '✔ Use at least 8 characters'
                      : '✘ Use at least 8 characters'}
                  </p>
                  <p
                    className={
                      passwordStrength.uppercase
                        ? 'text-green-600'
                        : 'text-red-600'
                    }
                  >
                    {passwordStrength.uppercase
                      ? '✔ Add at least one uppercase letter'
                      : '✘ Add at least one uppercase letter'}
                  </p>
                  <p
                    className={
                      passwordStrength.lowercase
                        ? 'text-green-600'
                        : 'text-red-600'
                    }
                  >
                    {passwordStrength.lowercase
                      ? '✔ Add at least one lowercase letter'
                      : '✘ Add at least one lowercase letter'}
                  </p>
                  <p
                    className={
                      passwordStrength.number
                        ? 'text-green-600'
                        : 'text-red-600'
                    }
                  >
                    {passwordStrength.number
                      ? '✔ Include at least one number'
                      : '✘ Include at least one number'}
                  </p>
                  <p
                    className={
                      passwordStrength.specialChar
                        ? 'text-green-600'
                        : 'text-red-600'
                    }
                  >
                    {passwordStrength.specialChar
                      ? '✔ Include at least one special character'
                      : '✘ Include at least one special character'}
                  </p>
                </div>
              )}
            </div>
            {errors.password && (
              <p className="text-red-500 text-xs mb-0 -mt-2">
                {errors.password}
              </p>
            )}

            {/* Re type password */}
            <div className="relative">
              <input
                type={passwordReTypeVisible ? 'text' : 'password'}
                placeholder="Confirm Password"
                className="border  border-gray-300 rounded-md py-2 px-4 w-full text-xs"
                value={ReTypepassword}
                onChange={e => setReTypepassword(e.target.value)}
                onKeyDown={handleSignUpKey}
              />
              <button
                type="button"
                onClick={toggleReTypePasswordVisibility}
                className="absolute inset-y-0 right-0 flex items-center px-3 focus:outline-none text-gray-500"
              >
                {passwordReTypeVisible ? <FaEye /> : <FaEyeSlash />}
              </button>
            </div>
            {errors.ReTypepassword && (
              <p className="text-red-500 text-xs mb-0 -mt-2">
                {errors.ReTypepassword}
              </p>
            )}

            {/* Dropdowns */}
            <div className="">
              <div className="flex flex-row md:flex-row md:items-center items-center md:gap-2 text-xs md:mb-4 mb-4">
                <label className=" w-1/3 ">
                  Location
                </label>
                <div className="flex items-center gap-2  w-full text-xs">
                  <LocationSelector onSelectLocation={handleLocationSelect} />
                </div>
              </div>
            </div>
            <div></div>

            {/* Create Account Button */}
            <button
              type="submit"
              onClick={handleSignUp}
              className={`w-full bg-EntryBG text-white py-1.5 px-6  mb-1 mt-2 rounded-md ${isButtonDisabled ? 'bg-gray-300 ' : 'bg-blue-500 hover:bg-btnHover cursor-pointer'}`}
              disabled={isButtonDisabled}
            >
              Create an Account
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUpAffilate



// import React, { useState, useEffect } from 'react';
// import { FaEye, FaEyeSlash } from 'react-icons/fa';
// import { useNavigate, useLocation } from 'react-router-dom';
// import LoginLogo from '../../Assets/images/Frame 39059 1.png';
// import LoginImg from '../../Assets/images/Registra.png';
// import GoogleLogo from '../../Assets/images/GoogleLogo.png';
// import SignupBackground from '../../Assets/images/SignupBackground.png';
// import Swal from 'sweetalert2';
// import apiClient from '../../Api/apiClient';
// import { API_BASE_URL } from '../../Api/config';
// import LocationSelector from '../../Components/Location/Location';
// const SignUpAffilate = ({ onSignUp }) => {
//   const [passwordVisible, setPasswordVisible] = useState(false);
//   const [password, setPassword] = useState('');
//   const [passwordReTypeVisible, setPasswordReTypeVisible] = useState(false);
//   const location = useLocation();
//   const { PricingBeforLogin, FromCheckoutAlert } = location.state || {};
//   const [userName, setUsername] = useState('');
//   const [email, setEmail] = useState('');
//   const [ReTypepassword, setReTypepassword] = useState('');
//   const [errors, setErrors] = useState({});
//   const [countryCode, setCountryCode] = useState('88'); // Set default country code
//   const [passwordStrength, setPasswordStrength] = useState({
//     minLength: false,
//     uppercase: false,
//     lowercase: false,
//     number: false,
//     specialChar: false,
//   });
//   const [selectedLocation, setSelectedLocation] = useState({
//     districtId: null,
//     districtName: '',
//     upazilaId: null,
//     upazilaName: '',
//   });
//   const [selectedCategory, setSelectedCategory] = useState({
//     subsectorId: null,
//     subsectorName: '',
//   });


//   const handleLocationSelect = (
//     districtId,
//     districtName,
//     upazilaId,
//     upazilaName
//   ) => {
//     setSelectedLocation({ districtId, districtName, upazilaId, upazilaName });
//   };

//   const navigate = useNavigate();

//   const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);
//   const toggleReTypePasswordVisibility = () =>
//     setPasswordReTypeVisible(!passwordReTypeVisible);

//   const validateForm = () => {
//     const newErrors = {};
//     if (!userName) newErrors.userName = 'Phone is required';
//     // if (!email) newErrors.userName = 'Email is required';
//     if (!password) newErrors.password = 'Password is required';
//     if (!ReTypepassword)
//       newErrors.ReTypepassword = 'confirm Password is required';
//     return newErrors;
//   };


//   const handleSignUp = async () => {
//     const validationErrors = validateForm();

//     const formData = {
//       phone: `${countryCode}${userName}`,
//       email: email,
//       password: password,
//       retype_password: ReTypepassword,
//       district_id: selectedLocation.districtId,
//       upazila_id: selectedLocation.upazilaId,
//       // sub_sector_id: selectedCategory,
//       sub_sector_id: selectedCategory.subsectorId,
//     };
//     // console.log('before api call', formData);

//     if (Object.keys(validationErrors).length === 0) {
//       try {
//         const response = await apiClient.post(
//           `${API_BASE_URL}/auth/affiliator/sign-up`,
//           formData
//         );
//         const {
//           data: { user_type },
//         } = response.data;
//         // console.log('Signup successful:', response);
//         const successMessage = response.data.message;
//         Swal.fire({
//           title: 'Success!',
//           text: successMessage,
//           confirmButtonText: 'Okay',
//           customClass: {
//             popup: 'w-72 h-auto p-3',
//             title: 'text-lg',
//             content: 'text-xs',
//             confirmButton:
//               'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
//           },
//         });
//         // navigate to OTP page
//         navigate('/otp', {
//           state: {
//             phone: `${countryCode}${userName}`,
//             PricingBeforLogin: PricingBeforLogin,
//             FromCheckoutAlert: FromCheckoutAlert,
//             user_type: user_type,
//           },
//         });
//       } catch (error) {
//         console.error('Signup failed:', error);
//         const errorMessage = error.response?.data?.message;
//         // error.response?.data?.message || 'An unknown error occurred';
//         Swal.fire({
//           title: 'Failed!',
//           text: errorMessage,
//           confirmButtonText: 'Okay',
//           customClass: {
//             popup: 'w-72 h-auto p-3',
//             title: 'text-lg',
//             content: 'text-xs',
//             confirmButton:
//               'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
//           },
//         });
//       }
//     } else {
//       setErrors(validationErrors);
//     }
//   };

//   const handleSignUpKey = e => {
//     if (e.key === 'Enter') {
//       handleSignUp();
//     }
//   };
//   // Validate Password Strength
//   const handlePasswordChange = value => {
//     setPassword(value);
//     setPasswordStrength({
//       minLength: value.length >= 8,
//       uppercase: /[A-Z]/.test(value),
//       lowercase: /[a-z]/.test(value),
//       number: /\d/.test(value),
//       specialChar: /[!@#$%^&*]/.test(value),
//     });
//   };


//   useEffect(() => {
//     const checkUserDetails = async () => {
//       if (userName || email) {
//         const phoneNumber = `${countryCode}${userName}`;
//         const { phoneExists, emailExists } = await checkUserExists(phoneNumber, email);

//         if (phoneExists) {
//           setErrors((prevErrors) => ({
//             ...prevErrors,
//             userName: 'This phone number is already registered.',
//           }));
//         } else if (emailExists) {
//           setErrors((prevErrors) => ({
//             ...prevErrors,
//             email: 'This email is already registered.',
//           }));
//         } else {
//           setErrors((prevErrors) => ({
//             ...prevErrors,
//             userName: '',
//             email: '',
//           }));
//         }
//       }
//     };

//     checkUserDetails();
//   }, [userName, email, countryCode]);
  

//   const checkUserExists = async (phone, email) => {
//     try {
//       const queryParams = new URLSearchParams();
//       if (phone) queryParams.append('key', phone); 
//       if (email) queryParams.append('key', email); 
//        queryParams.append('user_type', "affiliator"); 

//       // Make the API call with the constructed query string
//       const response = await apiClient.get(
//         `${API_BASE_URL}/user/visitor/users?${queryParams.toString()}`
//       );

//       return response.data; 
//     } catch (error) {
//       console.error('Error checking user details:', error);
//       return { phoneExists: false, emailExists: false }; 
//     }
//   };

//   return (
//     <div
//       className="flex items-center bg-center object-cover justify-center px-4 py-4"
//       style={{ backgroundImage: `url(${SignupBackground})` }}
//     >
//       <div className="flex flex-col lg:flex-row overflow-hidden max-w-5xl w-full rounded-lg border">
//         {/* Left Section */}
//         <div className="lg:w-1/2 w-full md:p-6 md:pt-0 p-0 flex flex-col items-center justify-center">
//           <img src={LoginLogo} alt="TenderWise Logo" className="h-16 " />
//           <h1 className="text-sm text-gray-600 text-center mb-2">
//             Register and join as a Affiliator
//           </h1>
//           <img
//             src={LoginImg}
//             alt="Illustration"
//             className="md:mt-4 w-72 h-60 max-w-xs lg:max-w-sm md:block hidden"
//           />
//         </div>

//         {/* Right Section */}
//         <div className="lg:w-1/2 w-full md:p-8 p-2">
//           <h2 className="md:text-xl text-lg font-semibold text-gray-800 text-center ">
//             Create an account
//           </h2>
//           <p className="text-sm text-center text-gray-600 mb-4">
//             Already have an account?{' '}
//             <button
//               // onClick={() => navigate('/login', {state:{ userType: 'affiliator'}})}
//               onClick={() => navigate('/affiliator-login')}
//               className="font-semibold hover:underline"
//             >
//               Log In
//             </button>
//           </p>
//           {/* Form */}
//           <div className="space-y-2 mt-2">
//             {/* username*/}
//             <div className="flex space-x-1">
//               <select
//                 className="border text-xs border-gray-300 rounded-md py-2 px-1 w-24"
//                 value={countryCode}
//                 onChange={e => setCountryCode(e.target.value)}
//               >
//                 <option value="88">+88(Ban)</option>
//                 <option value="1">+1(USA/Canada)</option>
//                 <option value="44">+44(UK)</option>
//                 <option value="91">+91(India)</option>
//                 <option value="61">+61(Aust)</option>
//                 <option value="33">+33(France)</option>
//                 <option value="49">+49(Germany)</option>
//                 <option value="39">+39(Italy)</option>
//                 <option value="81">+81(Japan)</option>
//                 <option value="7">+7(Russia)</option>
//                 <option value="86">+86(China)</option>
//                 <option value="34">+34(Spain)</option>
//                 <option value="55">+55(Brazil)</option>
//                 <option value="27">+27(SA)</option>
//                 <option value="52">+52(Mexico)</option>
//                 <option value="20">+20(Egypt)</option>
//                 <option value="45">+45(Denmark)</option>
//                 <option value="31">+31(Netherlands)</option>
//                 <option value="90">+90(Turkey)</option>
//                 <option value="63">+63(Philippines)</option>
//                 <option value="66">+66(Thailand)</option>
//                 <option value="32">+32(Belgium)</option>
//                 <option value="56">+56(Chile)</option>
//                 <option value="46">+46(Sweden)</option>
//                 <option value="351">+351(Portugal)</option>
//                 <option value="965">+965(Kuwait)</option>
//                 <option value="971">+971(UAE)</option>
//                 <option value="30">+30(Greece)</option>
//                 <option value="972">+972(Israel)</option>
//                 <option value="964">+964(Iraq)</option>
//                 <option value="256">+256(Uganda)</option>
//               </select>
//               <input
//                 type="text"
//                 placeholder="Enter Phone Number"
//                 className="border text-xs border-gray-300 rounded-md py-2 px-2 w-full"
//                 value={userName}
//                 onChange={e => setUsername(e.target.value)}
//                 onKeyDown={handleSignUpKey}
//               />
//             </div>
//             {errors.userName && (
//               <p className="text-red-500 text-xs mb-0 -mt-2">
//                 {errors.userName}
//               </p>
//             )}

//             {/* Email */}
//             <div>
//               <input
//                 type="email"
//                 id="email"
//                 placeholder="Enter your Email"
//                 className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 text-xs focus:ring-blue-500 focus:border-blue-500"
//                 value={email}
//                 onChange={e => setEmail(e.target.value)}
//                 onKeyDown={handleSignUpKey}
//               />
//             </div>

//             {/* Password */}
//             <div>
//               <div className="relative">
//                 <input
//                   type={passwordVisible ? 'text' : 'password'}
//                   id="password"
//                   placeholder="Enter your password"
//                   className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 text-xs focus:ring-blue-500 focus:border-blue-500"
//                   value={password}
//                   onChange={e => handlePasswordChange(e.target.value)}
//                 />
//                 <button
//                   type="button"
//                   className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500"
//                   onClick={togglePasswordVisibility}
//                 >
//                   {passwordVisible ? <FaEye /> : <FaEyeSlash />}
//                 </button>
//               </div>
//               {/* Password Strength Checklist */}
//               {password && (
//                 <div className="mt-2 text-xs text-gray-600 space-y-1">
//                   <p
//                     className={
//                       passwordStrength.minLength
//                         ? 'text-green-600'
//                         : 'text-red-600'
//                     }
//                   >
//                     {passwordStrength.minLength
//                       ? '✔ Use at least 8 characters'
//                       : '✘ Use at least 8 characters'}
//                   </p>
//                   <p
//                     className={
//                       passwordStrength.uppercase
//                         ? 'text-green-600'
//                         : 'text-red-600'
//                     }
//                   >
//                     {passwordStrength.uppercase
//                       ? '✔ Add at least one uppercase letter'
//                       : '✘ Add at least one uppercase letter'}
//                   </p>
//                   <p
//                     className={
//                       passwordStrength.lowercase
//                         ? 'text-green-600'
//                         : 'text-red-600'
//                     }
//                   >
//                     {passwordStrength.lowercase
//                       ? '✔ Add at least one lowercase letter'
//                       : '✘ Add at least one lowercase letter'}
//                   </p>
//                   <p
//                     className={
//                       passwordStrength.number
//                         ? 'text-green-600'
//                         : 'text-red-600'
//                     }
//                   >
//                     {passwordStrength.number
//                       ? '✔ Include at least one number'
//                       : '✘ Include at least one number'}
//                   </p>
//                   <p
//                     className={
//                       passwordStrength.specialChar
//                         ? 'text-green-600'
//                         : 'text-red-600'
//                     }
//                   >
//                     {passwordStrength.specialChar
//                       ? '✔ Include at least one special character'
//                       : '✘ Include at least one special character'}
//                   </p>
//                 </div>
//               )}
//             </div>
//             {errors.password && (
//               <p className="text-red-500 text-xs mb-0 -mt-2">
//                 {errors.password}
//               </p>
//             )}

//             {/* Re type password */}
//             <div className="relative">
//               <input
//                 // type="password"
//                 type={passwordReTypeVisible ? 'text' : 'password'}
//                 placeholder="Confirm Password"
//                 className="border  border-gray-300 rounded-md py-2 px-4 w-full text-xs"
//                 value={ReTypepassword}
//                 onChange={e => setReTypepassword(e.target.value)}
//                 onKeyDown={handleSignUpKey}
//               />
//               <button
//                 type="button"
//                 onClick={toggleReTypePasswordVisibility}
//                 className="absolute inset-y-0 right-0 flex items-center px-3 focus:outline-none text-gray-500"
//               >
//                 {passwordReTypeVisible ? <FaEye /> : <FaEyeSlash />}
//               </button>
//             </div>
//             {errors.ReTypepassword && (
//               <p className="text-red-500 text-xs mb-0 -mt-2">
//                 {errors.ReTypepassword}
//               </p>
//             )}

//             {/* Dropdowns */}
//             <div className="">
//               <div className="flex flex-col md:flex-row md:items-center items-start md:gap-2 text-xs md:mb-4 mb-4">
//                 <label className="md:w-1/3 w-full mb-1">
//                   Select Your Location
//                 </label>
//                 <div className="flex items-center gap-2 md:w-4/6 w-full text-xs">
//                   <LocationSelector onSelectLocation={handleLocationSelect} />
//                 </div>
//               </div>
//             </div>
//             <div></div>

//             {/* Create Account Button */}
//             <button
//               type="submit"
//               onClick={handleSignUp}
//               className="w-full bg-EntryBG text-white py-1.5 px-6 hover:bg-btnHover mb-1 mt-2 rounded-md"
//             >
//               Create an Account
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SignUpAffilate;






























// import React, { useState, useEffect } from 'react';
// import { FaEye, FaEyeSlash } from 'react-icons/fa';
// import { useNavigate, useLocation } from 'react-router-dom';
// import LoginLogo from '../../Assets/images/Frame 39059 1.png';
// import LoginImg from '../../Assets/images/Registra.png';
// import GoogleLogo from '../../Assets/images/GoogleLogo.png';
// import SignupBackground from '../../Assets/images/SignupBackground.png';
// import Swal from 'sweetalert2';
// import apiClient from '../../Api/apiClient';
// import { API_BASE_URL } from '../../Api/config';
// import LocationSelector from '../../Components/Location/Location';
// const SignUpAffilate = ({ onSignUp }) => {
//   const [passwordVisible, setPasswordVisible] = useState(false);
//   const [password, setPassword] = useState('');
//   const [passwordReTypeVisible, setPasswordReTypeVisible] = useState(false);
//   const location = useLocation();
//   const { PricingBeforLogin, FromCheckoutAlert } = location.state || {};
//   const [userName, setUsername] = useState('');
//   const [email, setEmail] = useState('');
//   const [ReTypepassword, setReTypepassword] = useState('');
//   const [errors, setErrors] = useState({});
//   const [countryCode, setCountryCode] = useState('88'); // Set default country code
//   const [passwordStrength, setPasswordStrength] = useState({
//     minLength: false,
//     uppercase: false,
//     lowercase: false,
//     number: false,
//     specialChar: false,
//   });
//   const [selectedLocation, setSelectedLocation] = useState({
//     districtId: null,
//     districtName: '',
//     upazilaId: null,
//     upazilaName: '',
//   });
//   const [selectedCategory, setSelectedCategory] = useState({
//     subsectorId: null,
//     subsectorName: '',
//   });


//   const handleLocationSelect = (
//     districtId,
//     districtName,
//     upazilaId,
//     upazilaName
//   ) => {
//     setSelectedLocation({ districtId, districtName, upazilaId, upazilaName });
//   };

//   const navigate = useNavigate();

//   const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);
//   const toggleReTypePasswordVisibility = () =>
//     setPasswordReTypeVisible(!passwordReTypeVisible);

//   const validateForm = () => {
//     const newErrors = {};
//     if (!userName) newErrors.userName = 'Phone is required';
//     // if (!email) newErrors.userName = 'Email is required';
//     if (!password) newErrors.password = 'Password is required';
//     if (!ReTypepassword)
//       newErrors.ReTypepassword = 'confirm Password is required';
//     return newErrors;
//   };


//   const handleSignUp = async () => {
//     const validationErrors = validateForm();

//     const formData = {
//       phone: `${countryCode}${userName}`,
//       email: email,
//       password: password,
//       retype_password: ReTypepassword,
//       district_id: selectedLocation.districtId,
//       upazila_id: selectedLocation.upazilaId,
//       // sub_sector_id: selectedCategory,
//       sub_sector_id: selectedCategory.subsectorId,
//     };
//     // console.log('before api call', formData);

//     if (Object.keys(validationErrors).length === 0) {
//       try {
//         const response = await apiClient.post(
//           `${API_BASE_URL}/auth/affiliator/sign-up`,
//           formData
//         );
//            const {
//              data: {user_type},
//            } = response.data;
//         // console.log('Signup successful:', response);
//         const successMessage = response.data.message;
//         Swal.fire({
//           title: 'Success!',
//           text: successMessage,
//           confirmButtonText: 'Okay',
//           customClass: {
//             popup: 'w-72 h-auto p-3',
//             title: 'text-lg',
//             content: 'text-xs',
//             confirmButton:
//               'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
//           },
//         });
//         // navigate to OTP page
//         navigate('/otp', {
//           state: {
//             phone: `${countryCode}${userName}`,
//             PricingBeforLogin: PricingBeforLogin,
//             FromCheckoutAlert: FromCheckoutAlert,
//             user_type: user_type,
//           },
//         });
//       } catch (error) {
//         console.error('Signup failed:', error);
//         const errorMessage = error.response?.data?.message;
//           // error.response?.data?.message || 'An unknown error occurred';
//         Swal.fire({
//           title: 'Failed!',
//           text: errorMessage,
//           confirmButtonText: 'Okay',
//           customClass: {
//             popup: 'w-72 h-auto p-3',
//             title: 'text-lg',
//             content: 'text-xs',
//             confirmButton:
//               'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
//           },
//         });
//       }
//     } else {
//       setErrors(validationErrors);
//     }
//   };

//   const handleSignUpKey = e => {
//     if (e.key === 'Enter') {
//       handleSignUp();
//     }
//   };
//   // Validate Password Strength
//   const handlePasswordChange = value => {
//     setPassword(value);
//     setPasswordStrength({
//       minLength: value.length >= 8,
//       uppercase: /[A-Z]/.test(value),
//       lowercase: /[a-z]/.test(value),
//       number: /\d/.test(value),
//       specialChar: /[!@#$%^&*]/.test(value),
//     });
//   };

//   return (
//     <div
//       className="flex items-center bg-center object-cover justify-center px-4 py-4"
//       style={{ backgroundImage: `url(${SignupBackground})` }}
//     >
//       <div className="flex flex-col lg:flex-row overflow-hidden max-w-5xl w-full rounded-lg border">
//         {/* Left Section */}
//         <div className="lg:w-1/2 w-full md:p-6 md:pt-0 p-0 flex flex-col items-center justify-center">
//           <img src={LoginLogo} alt="TenderWise Logo" className="h-16 " />
//           <h1 className="text-sm text-gray-600 text-center mb-2">
//             Register and join as a Affiliator
//           </h1>
//           <img
//             src={LoginImg}
//             alt="Illustration"
//             className="md:mt-4 w-72 h-60 max-w-xs lg:max-w-sm md:block hidden"
//           />
//         </div>

//         {/* Right Section */}
//         <div className="lg:w-1/2 w-full md:p-8 p-2">
//           <h2 className="md:text-xl text-lg font-semibold text-gray-800 text-center ">
//             Create an account
//           </h2>
//           <p className="text-sm text-center text-gray-600 mb-4">
//             Already have an account?{' '}
//             <button
//               // onClick={() => navigate('/login', {state:{ userType: 'affiliator'}})}
//               onClick={() => navigate('/affiliator-login')}
//               className="font-semibold hover:underline"
//             >
//               Log In
//             </button>
//           </p>
//           {/* Form */}
//           <div className="space-y-2 mt-2">
//             {/* username*/}
//             <div className="flex space-x-1">
//               <select
//                 className="border text-xs border-gray-300 rounded-md py-2 px-1 w-24"
//                 value={countryCode}
//                 onChange={e => setCountryCode(e.target.value)}
//               >
//                 <option value="88">+88(Ban)</option>
//                 <option value="1">+1(USA/Canada)</option>
//                 <option value="44">+44(UK)</option>
//                 <option value="91">+91(India)</option>
//                 <option value="61">+61(Aust)</option>
//                 <option value="33">+33(France)</option>
//                 <option value="49">+49(Germany)</option>
//                 <option value="39">+39(Italy)</option>
//                 <option value="81">+81(Japan)</option>
//                 <option value="7">+7(Russia)</option>
//                 <option value="86">+86(China)</option>
//                 <option value="34">+34(Spain)</option>
//                 <option value="55">+55(Brazil)</option>
//                 <option value="27">+27(SA)</option>
//                 <option value="52">+52(Mexico)</option>
//                 <option value="20">+20(Egypt)</option>
//                 <option value="45">+45(Denmark)</option>
//                 <option value="31">+31(Netherlands)</option>
//                 <option value="90">+90(Turkey)</option>
//                 <option value="63">+63(Philippines)</option>
//                 <option value="66">+66(Thailand)</option>
//                 <option value="32">+32(Belgium)</option>
//                 <option value="56">+56(Chile)</option>
//                 <option value="46">+46(Sweden)</option>
//                 <option value="351">+351(Portugal)</option>
//                 <option value="965">+965(Kuwait)</option>
//                 <option value="971">+971(UAE)</option>
//                 <option value="30">+30(Greece)</option>
//                 <option value="972">+972(Israel)</option>
//                 <option value="964">+964(Iraq)</option>
//                 <option value="256">+256(Uganda)</option>
//               </select>
//               <input
//                 type="text"
//                 placeholder="Enter Phone Number"
//                 className="border text-xs border-gray-300 rounded-md py-2 px-2 w-full"
//                 value={userName}
//                 onChange={e => setUsername(e.target.value)}
//                 onKeyDown={handleSignUpKey}
//               />
//             </div>
//             {errors.userName && (
//               <p className="text-red-500 text-xs mb-0 -mt-2">
//                 {errors.userName}
//               </p>
//             )}

//             {/* Email */}
//             <div>
//               <input
//                 type="email"
//                 id="email"
//                 placeholder="Enter your Email"
//                 className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 text-xs focus:ring-blue-500 focus:border-blue-500"
//                 value={email}
//                 onChange={e => setEmail(e.target.value)}
//                 onKeyDown={handleSignUpKey}
//               />
//             </div>

//             {/* Password */}
//             <div>
//               <div className="relative">
//                 <input
//                   type={passwordVisible ? 'text' : 'password'}
//                   id="password"
//                   placeholder="Enter your password"
//                   className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 text-xs focus:ring-blue-500 focus:border-blue-500"
//                   value={password}
//                   onChange={e => handlePasswordChange(e.target.value)}
//                 />
//                 <button
//                   type="button"
//                   className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500"
//                   onClick={togglePasswordVisibility}
//                 >
//                   {passwordVisible ? <FaEye /> : <FaEyeSlash />}
//                 </button>
//               </div>
//               {/* Password Strength Checklist */}
//               {password && (
//                 <div className="mt-2 text-xs text-gray-600 space-y-1">
//                   <p
//                     className={
//                       passwordStrength.minLength
//                         ? 'text-green-600'
//                         : 'text-red-600'
//                     }
//                   >
//                     {passwordStrength.minLength
//                       ? '✔ Use at least 8 characters'
//                       : '✘ Use at least 8 characters'}
//                   </p>
//                   <p
//                     className={
//                       passwordStrength.uppercase
//                         ? 'text-green-600'
//                         : 'text-red-600'
//                     }
//                   >
//                     {passwordStrength.uppercase
//                       ? '✔ Add at least one uppercase letter'
//                       : '✘ Add at least one uppercase letter'}
//                   </p>
//                   <p
//                     className={
//                       passwordStrength.lowercase
//                         ? 'text-green-600'
//                         : 'text-red-600'
//                     }
//                   >
//                     {passwordStrength.lowercase
//                       ? '✔ Add at least one lowercase letter'
//                       : '✘ Add at least one lowercase letter'}
//                   </p>
//                   <p
//                     className={
//                       passwordStrength.number
//                         ? 'text-green-600'
//                         : 'text-red-600'
//                     }
//                   >
//                     {passwordStrength.number
//                       ? '✔ Include at least one number'
//                       : '✘ Include at least one number'}
//                   </p>
//                   <p
//                     className={
//                       passwordStrength.specialChar
//                         ? 'text-green-600'
//                         : 'text-red-600'
//                     }
//                   >
//                     {passwordStrength.specialChar
//                       ? '✔ Include at least one special character'
//                       : '✘ Include at least one special character'}
//                   </p>
//                 </div>
//               )}
//             </div>
//             {errors.password && (
//               <p className="text-red-500 text-xs mb-0 -mt-2">
//                 {errors.password}
//               </p>
//             )}

//             {/* Re type password */}
//             <div className="relative">
//               <input
//                 // type="password"
//                 type={passwordReTypeVisible ? 'text' : 'password'}
//                 placeholder="Confirm Password"
//                 className="border  border-gray-300 rounded-md py-2 px-4 w-full text-xs"
//                 value={ReTypepassword}
//                 onChange={e => setReTypepassword(e.target.value)}
//                 onKeyDown={handleSignUpKey}
//               />
//               <button
//                 type="button"
//                 onClick={toggleReTypePasswordVisibility}
//                 className="absolute inset-y-0 right-0 flex items-center px-3 focus:outline-none text-gray-500"
//               >
//                 {passwordReTypeVisible ? <FaEye /> : <FaEyeSlash />}
//               </button>
//             </div>
//             {errors.ReTypepassword && (
//               <p className="text-red-500 text-xs mb-0 -mt-2">
//                 {errors.ReTypepassword}
//               </p>
//             )}

//             {/* Dropdowns */}
//             <div className="">
//               <div className="flex flex-col md:flex-row md:items-center items-start md:gap-2 text-xs md:mb-4 mb-4">
//                 <label className="md:w-1/3 w-full mb-1">
//                   Select Your Location
//                 </label>
//                 <div className="flex items-center gap-2 md:w-4/6 w-full text-xs">
//                   <LocationSelector onSelectLocation={handleLocationSelect} />
//                 </div>
//               </div>
//             </div>
//             <div></div>

//             {/* Create Account Button */}
//             <button
//               type="submit"
//               onClick={handleSignUp}
//               className="w-full bg-EntryBG text-white py-1.5 px-6 hover:bg-btnHover mb-1 mt-2 rounded-md"
//             >
//               Create an Account
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SignUpAffilate;
